import * as React from "react";
import { DetailsList, mergeStyles, Stack } from "@fluentui/react";
import { VariantDetail } from "../../../../Types";
import { getVariantDetailsColumns } from "./variantDetailsFormTableColumnDefinitions";
import { noTableItemsRenderer } from "../../../../Shared/TableRenderers";
import { styles } from "../variantDetailsFormStyles";

interface VariantDetailsFormTableProps {
  /**
   * When true, shows form for control variant
   */
  isControl: boolean;
  /**
   * Array of variant details to display in the table
   */
  variants: VariantDetail[];
  /**
   * Callback used when user clicks delete on a variant
   */
  onDelete: (variantDetail: VariantDetail) => void;
  /**
   * Callback used when user clicks edit on a variant
   */
  onEdit: (variantDetail: VariantDetail) => void;
  /**
   * Callback used when user removes a feature flag from a variant
   */
  onRemoveFlag: (variantDetail: VariantDetail, flag: string) => void;
  /**
   * When true, disables the table and all interactions
   */
  disabled?: boolean;
}

/**
 * Table component for displaying variant details for control/treatment variants.
 * Shows variant names, feature flags, and action buttons.
 */
const VariantDetailsFormTable: React.FC<VariantDetailsFormTableProps> = ({
  isControl,
  variants,
  onDelete,
  onEdit,
  onRemoveFlag,
  disabled = false,
}) => {
  const noVariantsMessage = isControl
    ? "Control variant not set"
    : "Treatment variants not set";

  const variantDetailsColumns = getVariantDetailsColumns({
    onDelete,
    onEdit,
    onRemoveFlag,
  });
  return (
    <Stack className={styles.variantDetailsTableContainer}>
      <DetailsList
        items={variants}
        columns={variantDetailsColumns}
        selectionMode={0}
        className={mergeStyles(disabled && styles.variantDetailsTableDisabled)}
      />
      {variants.length === 0 && noTableItemsRenderer(noVariantsMessage)}
    </Stack>
  );
};

export default VariantDetailsFormTable;
